import { render, staticRenderFns } from "./SearchCriteria.vue?vue&type=template&id=ccf7720a"
import script from "./SearchCriteria.vue?vue&type=script&lang=js"
export * from "./SearchCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports